import {connect} from 'react-redux';

import BaseControl from '../BaseControl';

const BaseArrow = ({direction, handler}) => (
    <BaseControl catchKey={`Arrow${direction}`} handler={handler} />
);

const mapDispatchToProps = (dispatch, {change, nextImage}) => ({
    handler: () => dispatch(change(nextImage)),
});

export default connect(null, mapDispatchToProps)(BaseArrow);
